var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconPremiumTools = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53.999,
    viewBox: "0 0 54 53.999",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 1,
    y2: 1.122,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b246a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37c7f0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    "data-name": "Union 5",
    d: "M5313,3857a27,27,0,1,1,27,27A27,27,0,0,1,5313,3857Zm11.444-15.556A22,22,0,1,0,5340,3835,21.855,21.855,0,0,0,5324.444,3841.444Zm21.034,29.2-6.97-6.969a12,12,0,0,1-2.575.28h-.066a11.185,11.185,0,0,1-11.139-11.138,10.814,10.814,0,0,1,1.878-6.292l.267-.395,7.388,7.167a1.849,1.849,0,0,0,1.273.64c.041,0,.081,0,.123,0a1.827,1.827,0,0,0,1.207-.454,1.833,1.833,0,0,0-.188-2.6l-.024-.022-7.154-7.155.411-.268a10.79,10.79,0,0,1,5.926-1.767h.038a11.035,11.035,0,0,1,11.034,11.251,11.966,11.966,0,0,1-.28,2.636l6.97,6.969a5.739,5.739,0,1,1-8.117,8.116Zm2.061-2.26a2.686,2.686,0,0,0,3.887,0l.021-.022a2.49,2.49,0,0,0,.826-1.925v-.012a2.678,2.678,0,0,0-.833-1.942l-.008-.008-8.141-8.139.381-1.4a7.665,7.665,0,0,0,.3-2.124,8.582,8.582,0,0,0-2.435-5.99,8.352,8.352,0,0,0-5.781-2.33h-.057a6.511,6.511,0,0,0-1.293.131l4.181,4.181a4.8,4.8,0,0,1,.225,6.838l-.015.015a4.8,4.8,0,0,1-6.838-.226l-4.165-4.164a8.533,8.533,0,0,0-.145,1.548v.007a7.729,7.729,0,0,0,2.427,5.764,8.361,8.361,0,0,0,5.79,2.338,7.706,7.706,0,0,0,2.121-.3H5338l1.394-.38Z",
    transform: "translate(-5313 -3830)",
    fill: "url(#linear-gradient)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPremiumTools, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-premium-tools.d7f97f8c.svg";
export { ForwardRef as ReactComponent };